import { Flex, theme, Typography } from 'antd';

const { Title, Text } = Typography;

export const CreateQuotationHeader = ({ isExternal }) => {
  const { token: themeToken } = theme.useToken();

  const title = isExternal
    ? '¡A un paso más cerca de asegurar tu vehículo!'
    : '¡A un paso más cerca de tu cliente!';

  const subtitle = isExternal
    ? 'Completa la información y en poco tiempo uno de nuestros asesores te ayudará a elegir el mejor seguro para tu vehículo'
    : 'Obtén cotizaciones en segundos';

  return (
    <Flex vertical gap={8} style={{ textAlign: 'center' }}>
      <Title style={{ color: themeToken.colorPrimary, margin: 0 }}>{title}</Title>
      <Text style={{ color: themeToken.colorPrimary }}>{subtitle}</Text>
    </Flex>
  );
};